export default __webpack_public_path__ + "static/media/accenture.7d5235e7.svg";